import { defineMessages } from 'react-intl';

/**
 * Only the row's own chrome is translated. Chip labels and prompt bodies live
 * in the server's starter catalogue (filespin-mcp-server
 * internal/prompts/starters.json) as plain English on purpose: the prompt text is sent
 * to the agent, whose system prompt and tool schemas are English, so
 * translating it would degrade tool selection. Revisit if/when the agent is
 * localized.
 */
export default defineMessages({
  lead: {
    id: 'comp.AgentNudgeRow.lead',
    defaultMessage: 'Ask the AI Agent',
  },
  askOpen: {
    id: 'comp.AgentNudgeRow.askOpen',
    defaultMessage: 'Ask about these…',
  },
  dismiss: {
    id: 'comp.AgentNudgeRow.dismiss',
    defaultMessage: 'Hide suggestions',
  },
  groupLabel: {
    id: 'comp.AgentNudgeRow.groupLabel',
    defaultMessage: 'AI Agent suggestions',
  },
});
